

export function getRootUrl()
{
	// return "";
	return "https://beccue.com";
	// return "http://localhost";
}

export function sendMQTT( device, topic, msg, that ) {
	const hostMqttBroker = 'home.beccue.com';
	const hostMqttUrl = getRootUrl()+'/mqtt.php';
	const url = hostMqttUrl + '?host=' + hostMqttBroker + '&device=' + device + '&topic=' + topic + '&msg=' + msg;

	console.log( url );

	fetch(url)
		.then(function (response) {
			// console.log(url + " -> " + response.ok);
			return response.json();
		})
		.then(function (data) {
			// console.log("data: "); console.dir(data);
			that.setState({ content: data.device + ' : ' + data.status });
		})
	.catch(function (err) {
			console.log("failed to load ", url, err.stack);
		});
}


//
// Usage: sendSMS( "+1 (760) 515-2323", "This is my third test from me to me." );
//
export function sendSMS( phoneNumber, message )
{
/*
	var TeleSignSDK = require('telesignsdk');
	const customerId = "284859A0-8D40-49AC-8971-F1E8AC29C4F2";
	const apiKey = "n4gNrSkDAEixbrf6tIBsFD4bHZWF2oup1BQ+lghyvopO6bDd2QD4SBoZnEc/ciVcqluNxz12xkSHrvS07UVj+A==";
	const rest_endpoint = "https://rest-api.telesign.com";
	const timeout = 10*1000; // 10 secs

	const client = new TeleSignSDK( customerId,
			apiKey,
			rest_endpoint,
			timeout // optional
			// userAgent
			);

	const messageType = "ARN";
*/

	phoneNumber = phoneNumber.replace(/[-+() ]/g,"");

	console.log("## MessagingClient.message ##");

	const url = getRootUrl()+'/sendSMS.php?phone='+phoneNumber+'&msg='+message;

	fetch(url)
		.then(function (response) {
			// console.log(url + " -> " + response.ok);
			return response.json();
		})
		.then(function (data) {
			// console.log("sms data response: " + data.response );
			return data.response;
		})
		.catch(function (err) {
			console.log("failed to load ", url, err.stack);
		});
}


export function isJsonString(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}

